<template>
  <div class="layout-page">
    <bottom></bottom>
    <download></download>
    <ios-home/>
    <div id="scroll-div-home" class="scroll-list aui-scrollView">
      <swiper v-if="pageInfo.adList.length > 0" :ad-list="pageInfo.adList"></swiper>
      <div class="search-word" style="background:#fff">
        <button @click="$router.push({name: 'book-search'})">{{getBookSearch.hotWords[0] || ''}}</button>
      </div>


      <div class="home-ls">
        <div class="aui-book-head">
          <h2>今日更新</h2>
          <div class="r">
            <a class="ccc" @click="changeCategory(selected.category)">换一批</a>
            <span @click="toNew" class="more">更多</span>
          </div>
        </div>
        <ul class="ul">
          <li v-for="(item, index) in categoryList" :key="item.id" :class="{ active: getCategoryActive === item.id }"
                @click="changeCategory(item.id,0)">{{ item.name }}</li>
        </ul>
        <div class="aui-list-theme">
          <router-link :to="{name: 'book-home', params: {id: book.bookId}}" v-for="book in updateBooks"
                       :key="book.bookId" class="aui-list-theme-item">
            <div class="aui-list-img">
              <img :imgpath="`${book.cover}_180_0.img`" v-lazy="require('../../assets/img/loading.jpeg')" alt/>
            </div>
            <div class="aui-list-title">
              <h3>{{ book.title }}</h3>
              <div class="aui-flex">
                <div class="aui-flex-box">
                  <span class="i-a">{{ book.categoryName }}</span>
                  <span v-if="book.publishStatus==='serialize'" class="i-c">连载中</span>
                  <span v-if="book.publishStatus==='finish'" class="i-b">已完结</span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div v-if="isLoading" class="home-loading"></div>
      </div>



      <template v-for="(item,index) in pageInfo.showcases">
        <template v-if="item.type == 'e_recommend'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="🍓草莓推荐"
            :books="item.books"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('e_recommend', currentPage.recommendList);"
            @show-more="toRecommend(item, '🍓草莓推荐')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'hot'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="🍓人气榜单"
            :books="item.books"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('hot', currentPage.hotList);"
            @show-more="toRecommend(item, '🍓人气榜单')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'kkbg'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="🍓草莓重磅"
            :books="item.books"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('kkbg', currentPage.kkbgList);"
            @show-more="toRecommend(item, '🍓草莓重磅')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'new_on'">
          <div class="divHeight" :key="index"></div>
          <books-small
            :key="item.name"
            title="🍓草莓新书"
            :books="item.books"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('new_on', currentPage.newOnList);"
            @show-more="toRecommend(item, '🍓草莓新书')"
          ></books-small>
        </template>
        <!-- <template v-if="item.type == 'new'">
          <div class="divHeight" :key="index"></div>
          <books-large
            :key="item.name"
            title="🍓每日更新"
            :books="item.books"
            @show-more="toRecommend(item, '🍓每日更新')"
          ></books-large>
        </template> -->
      </template>
    </div>
    <div v-if="isMainLoading" class="home-main-loading"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swiper from '@/components/share/swiper'
import BooksNormal from '@/components/share/books-normal'
import BooksSmall from '@/components/share/books-small'
import BooksLarge from '@/components/share/books-large'
import Bottom from '@/components/layer1/bottom'
import Download from '@/components/layer1/download'
import iosHome from '@/components/layer1/iosHome'
import homeService from '../../services/homeService'
import shelfService from '../../services/shelfService'
import swiperService from '../../services/swiperService'
import listService from '../../services/listService'

export default {
  name: 'home',
  data () {
    return {
      componentName: '',
      pageInfo: {
        adList: [],
        recommendList: [],
        showcases: [],
        hotList: [],
        kkbgList: [],
        newOnList: [],
      },
      historyList: [],
      key:{
        recommendList: 100,
        hotList: 200,
        kkbgList: 300,
        newOnList: 400,
      },
      currentPage:{
        recommendList: 1,
        hotList: 1,
        kkbgList: 1,
        newOnList: 1,
      },
      updateBooks: [],
      categoryList: [],
      selected: {
        category: 0,
        pageSize: 6,
      },
      todayUpdateBooks:[],
      todayUpdateCurrentPage: 0,
      isLoading: false,
      isMainLoading: false,
      isNoMoreData: false,
      totalItem: 0,
    }
  },
  computed: {
    getCategoryActive() {
      return this.selected.category
    },
    ...mapGetters(['getBookSearch', 'getHomeData'])
  },
  methods: {
    getIndexPage () {
      const { getHomeData } = this
      if (getHomeData) {
        this.pageInfo = getHomeData
        return
      }
      homeService
        .getIndexPage()
        .then(res => {
          const resData = res.data
          const adList = resData.adList || []
          this.pageInfo = resData
          swiperService.setAdList(adList)
          this.$store.commit('saveHomeData', resData)
          this.setHomeDataLocal(resData)
        })
        .catch(() => {
          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getIndexPage()
          })
        })
    },

    //获取分类
    getCategory () {
      listService.getCategory().then(res => {
        this.categoryList = res.data.categoryList
      })
    },
    //换一批
    changeCategory(id,page) {
      this.selected.category = id;
      if(page === 0){
        this.todayUpdateCurrentPage = 0;
      }
      this.getCategoryBooks(this.selected.category);
    },
    //请求下一批
    getCategoryBooks(category) {
      console.log(category)
      this.todayUpdateCurrentPage += 1;
      if(this.todayUpdateCurrentPage > 3){
        this.todayUpdateCurrentPage = 1
      }
      this.isLoading = true;
      this.isNoMoreData = false;
      this.updateBooks = [];
      let _category = category
      if (category === 0) {
        _category = ''
      }
      listService.getUpdateList(_category, this.selected.pageSize, this.todayUpdateCurrentPage, )
        .then(res => {
          this.isLoading = false;
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.updateBooks = [];
            } else {
              //vipDailySignConfigtodayUpdateBooks = res.data.bookList;
              this.updateBooks = res.data.bookList;
            }
            this.totalItem = res.data.totalItem;
            // this.vipDailySignConfig = res.data.vipDailySignConfig.split(',')
            // this.userDailySignConfig = res.data.userDailySignConfig.split(',')
            // this.currentSignDay = res.data.currentSignDay
            // this.selectSignDay = res.data.selectSignDay
            // this.alreadyBoundMobile = res.data.alreadyBoundMobile
          }
        })
    },
    //橱窗换一批
    showRefresh(type, page){
      this.isMainLoading = true
      let currentPage = page >= 3 ? 1 : page + 1
      listService.getRefreshList(type, currentPage)
        .then(res => {
          if (res.code === 200) {
              switch (type) {
                case 'e_recommend':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'e_recommend'){
                      this.pageInfo.showcases[key].books = res.data.bookList
                    }
                  }
                  //this.pageInfo.recommendList = res.data.bookList
                  this.currentPage.recommendList = currentPage
                  this.key.recommendList += 1
                  break;
                case 'hot':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'hot'){
                      this.pageInfo.showcases[key].books = res.data.bookList
                    }
                  }
                  //this.pageInfo.hotList = res.data.bookList
                  this.currentPage.hotList = currentPage
                  this.key.hotList += 1
                  break;
                case 'kkbg':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'kkbg'){
                      this.pageInfo.showcases[key].books = res.data.bookList
                    }
                  }
                  //this.pageInfo.kkbgList = res.data.bookList
                  this.currentPage.kkbgList = currentPage
                  this.key.kkbgList += 1
                  break;
                case 'new_on':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'new_on'){
                      this.pageInfo.showcases[key].books = res.data.bookList
                    }
                  }
                  //this.pageInfo.newOnList = res.data.bookList
                  this.currentPage.newOnList = currentPage
                  this.key.newOnList += 1
                  break;
              }
            this.isMainLoading = false
          }else{
            this.isMainLoading = false
          }
        })
    },

    
    setHomeDataLocal (data = {}) {
      window.localStorage.setItem('$_home_data', JSON.stringify(data))
    },
    getHomeDataLocal () {
      try {
        let data = window.localStorage.getItem('$_home_data')
        if (data) {
          data = JSON.parse(data)
          this.pageInfo = data
        }
      } catch (error) {}
    },
    loadHistory () {
      this.historyList = shelfService
        .getHistory()
        .map(item => item.bookInfo)
        .splice(0, 3)
    },
    toRecommend (item, title) {
      this.$router.isBack = false
      this.$router.push({
        path: '/home/recommend',
        query: { type: item.type, name: title }
      })
    },
    toRanked () {
      this.$router.isBack = false
      this.$router.push('/home/ranked')
    },
    toLatest () {
      this.$router.isBack = false
      this.$router.push('/home/latest')
    },
    toRecent () {
      this.$router.isBack = false
      this.$router.push({ path: '/shelf', query: { active: 'history' } })
    },
    toNew () {
      this.$router.isBack = false
      this.$router.push('/new')
    },
    getUpdateBooks () {
      listService.getUpdateList('', 6, 1).then(res => {
        const resData = res.data
        this.updateBooks = resData.bookList || []
      })
    }
  },
  components: {
    Download,
    iosHome,
    swiper: Swiper,
    'books-small': BooksSmall,
    'books-large': BooksLarge,
    BooksNormal,
    bottom: Bottom
  },
  created () {
    this.getHomeDataLocal()
    this.getCategory()
  },
  mounted () {
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-home')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    } else {
      this.getIndexPage()
      this.getUpdateBooks()
      this.loadHistory()
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    this.$dialog.close()
    const scrollDiv = document.getElementById('scroll-div-home')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>
.home-ls { background: linear-gradient(1turn, #f3dfb0 60%, #e75b9a) ; padding: 0; margin:5px; border-radius: 10px;min-height: 570px; position: relative; overflow: hidden;}
.home-ls .ccc{ padding:0 0.3rem 0 1.3rem; line-height: 1.2rem; height: 1.2rem; font-size: .8rem; border-radius: 1rem; border:1px solid #fff; display: inline-block;
  background:#fff url(../../assets/img/bg7.png) 0.3rem center no-repeat; background-size: 0.7rem; color: #91174e; margin-right: 20px;}
  .home-ls .aui-book-head h2{    color: #fff;}
  .home-ls .aui-book-head .more{ color: #fff !important;}
  .home-ls .aui-book-head h2:after{border-left: 4px solid #91174e;}
.home-ls .ul{ display: flex; margin: -3px 0 0.3rem 0.3rem; flex-direction: row; flex-wrap: wrap; text-align: center;justify-content: left;}
.home-ls .aui-list-img img{ min-height: 170px;}
.home-ls .ul li{ margin: 0 0.1rem 0.4rem 0.1rem;  text-align: center;font-size:.8rem; background: #91174e; height: 1.4rem; line-height: 1.4rem;
    padding: 0 15px; border-radius: 1rem; color: #fff;min-width: 3rem; border: 0px; text-align: center;}
.home-ls .ul li.active{ background: #fff; color: #91174e;}
.home-ls .aui-list-theme-item{ margin-bottom: 10px;}
.home-loading{position: absolute; background:#91174e url(../../assets/img/loading4.gif) center center no-repeat; background-size: 40px; top: 0px; left: 0; right: 0; bottom: 0; z-index: 500; opacity: .7;}

  .home-main-loading{position: fixed; background:#000 url(../../assets/img/loading4.gif) center center no-repeat; background-size: 40px; 
    top: calc(50% - 60px); left: calc(50% - 60px); z-index: 2020; opacity: .7; width: 120px; height: 120px; border-radius: 10px;}


</style>
